/**
 * feedbackService — submit beta feedback to create GitHub issues
 */
import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';

export const submitFeedback = async ({ title, category, description }) => {
  const submitBugReport = httpsCallable(functions, 'submitBugReport');
  const { data } = await submitBugReport({
    title,
    category,
    description,
    userAgent: navigator.userAgent,
    screenSize: `${screen.width}x${screen.height}`,
    pageUrl: window.location.href,
  });
  return data;
};
